import { useEffect, useRef, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import loader from "../../../assets/images/loader.gif";
import noimg from "../../../assets/images/noimg.webp";
import Pagination from "../../../components/common/Pagination";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  deleteProject,
  getUserWiseProject,
} from "../../../service/DashboardService";
import DoubleConfirm from "../../../components/dashboard/common/DoubleConfirm";
import UpdateProjectData from "../../../components/dashboard/user-dashboard/updateData/UpdateProjectData";

const UserProjectsList = () => {
  const navigate = useNavigate();
  const [userProjects, setUserProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const topRef = useRef(null);
  const [deletingProjectId, setDeletingProjectId] = useState(null);
  const [doubleAlert, setDoubleAlert] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [editProjectId, setEditProjectId] = useState(null);

  useEffect(() => {
    fetchData();
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const userId = localStorage.getItem("userId");
      const response = await getUserWiseProject(userId, token, currentPage, 10);
      setUserProjects(response);
      const totalProjects = response.length;
      const pages = Math.ceil(totalProjects / 10);
      setTotalPages(pages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDeleteProject = async (projectId) => {
    setDeletingProjectId(projectId);
    setDoubleAlert(true);
  };

  const confirmDeleteProject = async () => {
    try {
      await deleteProject(deletingProjectId);
      setUserProjects((prevProjects) =>
        prevProjects.filter(
          (project) => project.ProjectId !== deletingProjectId
        )
      );
      setDeletingProjectId(null);
      setDoubleAlert(false)
    } catch (error) {
      console.error("Error deleting project:", error);
    }
  };

  const handleEditProject = (projectId) => {
    setEditProjectId(projectId);
    setUpdateModal(true);
  };

  const renderTableRows = () => {
    return userProjects?.map((proj, i) => (
      <tr
        key={i}
        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
      >
        <td className="px-6 py-4">{proj.ProjectName || "NA"}</td>
        <td className="px-6 py-4">
          <img
            src={(proj.ImageUrls && proj.ImageUrls.length > 0 ? proj.ImageUrls[0] : null) || proj.Image1 || noimg}
            alt={proj.ProjectName || "Project Preview"}
            className="w-20 shadow-md object-cover"
            style={{ width: '80px', height: '80px' }}
          />
        </td>
        <td className="px-6 py-4">{proj.TypologyCategory || "NA"}</td>
        <td className="px-6 py-4">
          <ListAction
            isUserDashboard={true}
            onDeleteClick={() => handleDeleteProject(proj.ProjectId)}
            showDeleteButton={true}
            onEditClick={() => handleEditProject(proj.ProjectId)}
          />
        </td>
      </tr>
    ));
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div ref={topRef}>
        <TopHeader tabName={"Projects"} />
        <div className="flex justify-end mb-5">
          <button
            type="button"
            className="flex items-center gap-2 text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={() => navigate("/add-new-project")}
          >
            <IoMdAdd /> Add New Project
          </button>
        </div>

        <div>
          {loading ? (
            <div className="flex justify-center items-center h-screen">
              <img src={loader} alt="Loading" />
            </div>
          ) : (
            <div className="">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Name
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Main Image (Preview)
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Typology
                    </th>
                    <th scope="col" className="px-6 py-3">

                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userProjects.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        No records found
                      </td>
                    </tr>
                  ) : (
                    renderTableRows()
                  )}
                </tbody>
              </table>
              {userProjects.length > 10 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <DoubleConfirm
        open={doubleAlert}
        setOpen={setDoubleAlert}
        onConfirm={confirmDeleteProject}
      />
      <UpdateProjectData open={updateModal} setOpen={setUpdateModal} editProjectId={editProjectId} />
    </>
  );
};

export default UserProjectsList;
